export default __webpack_public_path__ + "static/media/background.7d974a9a.jpg";